/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogAccountCreationContainer_user$ref: FragmentReference;
export type LogAccountCreationContainer_user = {|
  +tabs: ?number,
  +$refType: LogAccountCreationContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogAccountCreationContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabs",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8cc603755d6dc31f91ced32ad999df9c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/LogAccountCreationContainer_user.graphql.js